import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import Series from '@/components/screens/series/Series';
import { ISeries } from '@/interfaces/series.interface';
import { getAlphabet } from '@/helpers/helpers';
import { SERIES_FOR_PAGE, API_URL } from '@/helpers/variables';

interface IAvtorLetterPageDynamicProps extends ISeries {
  letterSign: string;
}

const AvtorLetterPageDynamic: NextPage<IAvtorLetterPageDynamicProps> = ({ series, letterSign }) => {
  return <Series series={series} letterSign={letterSign} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { letterSign } = context.query;

  const res = await fetch(`${API_URL}series/?status=active&start_with=${getAlphabet(String(letterSign))}&page=1&page_size=${SERIES_FOR_PAGE}`);
  const series = await res.json();

  return {
    props: {
      series,
      letterSign,
    },
  };
};

export default AvtorLetterPageDynamic;
